import { useState, useEffect, useRef } from "react";
import { socket } from "../socket";
import { useDispatch, useSelector } from "react-redux";
import { caseActions } from "../store/case";
import { systemActions } from "../store/system";
import { applyDeletedNotesPatch } from "./applyNoteSoftDelete";
import { getItemFromStorageSimple, setStorageItem } from "./script";
import store from "../store";

export function useCaseSocket(caseId, user) {
    const [users, setUsers] = useState([]);
    const [isConnected, setIsConnected] = useState(false);
  const [tabSwitched] = useState(false);

    const activeTab = useSelector((state) => state.details.detailsTabs);

    useEffect(() => {
        if (!caseId || !user) return;
        // if (process.env.REACT_APP_ENVIRONMENT_SOCKET === 'development') return;

        // Connect socket
      if (!socket.connected) {
          socket.connect();
        }

        setIsConnected(socket.connected);

        // Join case
        // if (users.find(user => user.userId != userName)) {

        // }
        socket.emit("join-case", {
            caseId: caseId,
            userData: {
                userId: user.id,
                name: user.name,
                activeTab: activeTab,
            },
        });

        // Listen for events
      const joinedCaseHandler = (data) => {
            setUsers(data.users);
        };

      const userJoinedHandler = (data) => {
            setUsers(data.users);
        };

      const userLeftHandler = (data) => {
            setUsers(data.users);
        };

      const userDisconnectedHandler = (data) => {
            setUsers(data.users);
        };

      const userStatusChangedHandler = (data) => {
            setUsers((prevUsers) =>
                prevUsers.map((u) =>
                    u.userId === data.user.userId ? data.user : u,
                ),
            );
      };

      socket.on("joined-case", joinedCaseHandler);
      socket.on("user-joined", userJoinedHandler);
      socket.on("user-left", userLeftHandler);
      socket.on("user-disconnected", userDisconnectedHandler);
      socket.on("user-status-changed", userStatusChangedHandler);

        // socket.on(`case-updated-${caseId}`, (data) => {
        //     console.log("Case updated:", data);
        // });

        // socket.on("tab-switched", (data) => {
        //     console.log("Tab switched:", data);
        //     // setUsers(data.users);
        //     setTabSwitched(data);
        // });

        // Cleanup
        return () => {
            //  console.log("Leaving case");
            socket.emit("leave-case", { caseId });
          socket.off("joined-case", joinedCaseHandler);
          socket.off("user-joined", userJoinedHandler);
          socket.off("user-left", userLeftHandler);
          socket.off("user-disconnected", userDisconnectedHandler);
          socket.off("user-status-changed", userStatusChangedHandler);
            setIsConnected(false);
        };
    }, [caseId, user, activeTab]);

    return { users, isConnected, tabSwitched };
}

export function useCaseUpdated(caseId) {
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.user.user);

    useEffect(() => {
        if (!caseId) return;
      const eventName = `case-updated-${caseId}`;
      const caseUpdatedHandler = (data) => {
            console.log("case socket updated", data);
            // if (data.updated_by_id !== currentUser?.id) {
                // console.log("inside if", data);
                delete data.emittedAt;
                delete data.source;
                delete data.updated_by_id;
                // console.log("data", data);

                dispatch(caseActions.batchUpdate(data));
                applyDeletedNotesPatch(dispatch, data?.notes, caseId);
            // }

            // dispatch(notificationActions.setError({errorMessage: 'Case updated successfully', type: 'success'}));
      };

      socket.on(eventName, caseUpdatedHandler);

      return () => {
          socket.off(eventName, caseUpdatedHandler);
        };
    }, [caseId, currentUser?.id, dispatch]);
}

export function useCaseSynced(caseId, onSynced, isEnabled = true) {
    const dispatch = useDispatch()
    const onSyncedRef = useRef(onSynced)

    useEffect(() => {
        onSyncedRef.current = onSynced
    }, [onSynced])

    useEffect(() => {
        if (!isEnabled || !caseId) return

        if (!socket.connected) {
            socket.connect()
        }

        const eventName = `case-synced-${caseId}`
        const caseSyncedHandler = (data) => {
            // Keep parity with `case-updated-*` payload sanitation.
            if (data && typeof data === "object") {
                delete data.emittedAt
                delete data.source
                delete data.updated_by_id
            }

            if (data) {
                dispatch(caseActions.batchUpdate(data))
                applyDeletedNotesPatch(dispatch, data?.notes, caseId)
            }
            if (typeof onSyncedRef.current === "function") {
                onSyncedRef.current(data)
            }
        }

        socket.on(eventName, caseSyncedHandler)
        return () => {
            socket.off(eventName, caseSyncedHandler)
        }
    }, [caseId, dispatch, isEnabled])
}

export function useSystemSettingsUpdated(isEnabled = true) {
    useEffect(() => {
      if (!isEnabled) return;

      if (!socket.connected) {
        socket.connect();
      }

      const systemSettingsUpdatedHandler = (data) => {
            setStorageItem("settings", data.settings);
        if (data?.last_global_sync != null) {
          localStorage.setItem(
            'last_global_sync',
            data.last_global_sync,
          );
        }
        store.dispatch(systemActions.bumpSettingsRevision());
      };

      socket.on('system-settings-updated', systemSettingsUpdatedHandler);

        return () => {
          socket.off('system-settings-updated', systemSettingsUpdatedHandler);
        };
    }, [isEnabled]);
}

/**
 * Listen for admin "Send Live" system alerts and show them in the existing modal.
 */
export function useSystemAlertLive(isEnabled = true) {
    useEffect(() => {
        if (!isEnabled) return;

        if (!socket.connected) {
            socket.connect();
        }

        const systemAlertLiveHandler = (data) => {
            if (!data || data.id == null) {
                return;
            }

            const incoming = {
                id: data.id,
                subject: data.subject ?? '',
                description: data.description ?? '',
                force_on_login: data.force_on_login ?? false,
            };

            const current =
                store.getState().system.systemAlerts
                ?? getItemFromStorageSimple('persistentSystemAlerts')
                ?? [];

            const existingIndex = current.findIndex(
                (alert) => alert.id == incoming.id,
            );

            let next;
            if (existingIndex !== -1) {
                next = [...current];
                next[existingIndex] = { ...next[existingIndex], ...incoming };
            } else {
                next = [...current, incoming];
            }

            setStorageItem('persistentSystemAlerts', next);
            store.dispatch(systemActions.setSystemAlerts(next));
        };

        socket.on('system-alert-live', systemAlertLiveHandler);

        return () => {
            socket.off('system-alert-live', systemAlertLiveHandler);
        };
    }, [isEnabled]);
}
// * 60 * 2
export function useIdleStatus(caseId, user, idleTimeout = 1000 * 60 * 2 ) {
    const [status, setStatus] = useState('active');
    const statusRef = useRef(null);
  
    useEffect(() => {
      if (!caseId || !user) return;
  
      let idleTimer;
      let pingInterval;
  
      const setStatusAndEmit = (nextStatus) => {
        if (statusRef.current === nextStatus) {
          return;
        }
  
        statusRef.current = nextStatus;
        setStatus(nextStatus);
        let body = {
            caseId,
            userId: user.id,
            status: nextStatus
        } 
  
        socket.emit('update-status', body);
      };
  
      const resetIdleTimer = () => {
        clearTimeout(idleTimer);
  
        // Any interaction counts as active
        setStatusAndEmit('active');
  
        idleTimer = setTimeout(() => {
          setStatusAndEmit('idle');
        }, idleTimeout);
      };
  
      const handleVisibilityChange = () => {
        if (document.hidden) {
          setStatusAndEmit('idle');
        } else {
          // Treat becoming visible again as user activity
          setStatusAndEmit('active');
        }
      };
  
      // Track user activity
      const events = ['mousemove', 'keypress', 'click', 'scroll'];
      events.forEach(event => {
        document.addEventListener(event, resetIdleTimer);
      });
  
      document.addEventListener('visibilitychange', handleVisibilityChange);
  
      // Start activity ping
    //   pingInterval = setInterval(() => {
    //     socket.emit('activity-ping', { caseId });
    //   }, 5000);
  
      // Initialize timers and status
      resetIdleTimer();
  
      return () => {
        clearTimeout(idleTimer);
        clearInterval(pingInterval);
        events.forEach(event => {
          document.removeEventListener(event, resetIdleTimer);
        });
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }, [caseId, user, idleTimeout]);
  
    return status;
}